import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Navbar from './Navbar';
import FloatingCallButton from './FloatingCallButton';
import CookiesBanner from './CookiesBanner';
import ServiceContent from './ServiceContent';

const Layout: React.FC = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
        <ServiceContent />
      </main>
      <FloatingCallButton />
      <Footer />
      <CookiesBanner />
    </div>
  );
};

export default Layout;